<template>
  <div id="ProjectCarousel">
    <b-container class="tabs-container">
      <div class="tabs">
        <button
          v-for="(category, index) in projects"
          :key="'tab' + index"
          class="tab"
          :class="{ tabhighlight: indexes.currentCategoryIndex === index }"
          @click="categoryIndexSelected(index)"
        >
          {{
            languageHelper.translate(`category.${category.categoryName}`, {
              locale: global.locale,
            })
          }}
        </button>
      </div>
    </b-container>
    <b-container
      class="arrow-container arrow-extra"
      v-if="global.screenWidth <= 584"
    >
      <button
        id="prevArrow"
        :class="{ galArrow: true, grayArrow: indexes.currentPageIndex === 0 }"
        @click="pageIndexSelected(indexes.currentPageIndex - 1)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.343 185.343" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M51.707 185.343a10.692 10.692 0 01-7.593-3.149 10.724 10.724 0 010-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 01-7.587 3.15z" fill="#010002"/></svg>
      </button>
      <div class="pagination">
        <div
          v-for="(page, index) in pageCount"
          :key="'pageinator' + index"
          :class="{
            activePage:
              index === indexes.currentPageIndex ||
              index === nextIndexes.currentPageIndex,
          }"
          @click="pageIndexSelected(index)"
        />
      </div>
      <button
        id="nextArrow"
        :class="{
          galArrow: true,
          grayArrow: indexes.currentPageIndex === pageCount - 1,
        }"
        @click="pageIndexSelected(indexes.currentPageIndex + 1)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.343 185.343" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M51.707 185.343a10.692 10.692 0 01-7.593-3.149 10.724 10.724 0 010-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 01-7.587 3.15z" fill="#010002"/></svg>
      </button>
    </b-container>
    <b-container class="content-container" :class="{ slidingfade: sliding }">
      <div
        class="project-card"
        v-for="(project, index) in projects[
          indexes.currentCategoryIndex
        ].items.slice(
          Math.max(0, maxItems * indexes.currentPageIndex),
          Math.min(
            Math.max(0, maxItems * indexes.currentPageIndex) + maxItems,
            projects[indexes.currentCategoryIndex].items.length
          )
        )"
        :key="'project-card' + index"
      >
        <a
          :href="project.link"
          target="_blank"
          @click="analyticsHelper.clickedLink(`visit:${project.title}`)"
        >
          <img :src="project.thumbnail" />

          <div class="project-title">
            <span class="title">{{ project.title }}</span>
            <span class="visit">
              {{
                languageHelper.translate("common.visit", {
                  locale: global.locale,
                })
              }}</span
            >
          </div>
        </a>

        <span class="project-stack">
          {{ project.stack.filter((x) => x).join(" \u2022 ") }}
        </span>

        <span
          v-if="project.gallery || project.description"
          @click="
            setModalData({ modalType: 'project', data: project });
            analyticsHelper.modalOpen(project.title);
          "
          class="project-extra"
        >
          {{
            languageHelper.translate("common.moreDetails", {
              locale: global.locale,
            })
          }}
        </span>
      </div>
    </b-container>
    <b-container class="arrow-container">
      <button
        id="prevArrow"
        :class="{ galArrow: true, grayArrow: indexes.currentPageIndex === 0 }"
        @click="pageIndexSelected(indexes.currentPageIndex - 1)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.343 185.343" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M51.707 185.343a10.692 10.692 0 01-7.593-3.149 10.724 10.724 0 010-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 01-7.587 3.15z" fill="#010002"/></svg>
      </button>
      <div class="pagination">
        <div
          v-for="(page, index) in pageCount"
          :key="'pageinator' + index"
          :class="{
            activePage:
              index === indexes.currentPageIndex ||
              index === nextIndexes.currentPageIndex,
          }"
          @click="pageIndexSelected(index)"
        />
      </div>
      <button
        id="nextArrow"
        :class="{
          galArrow: true,
          grayArrow: indexes.currentPageIndex === pageCount - 1,
        }"
        @click="pageIndexSelected(indexes.currentPageIndex + 1)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.343 185.343" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M51.707 185.343a10.692 10.692 0 01-7.593-3.149 10.724 10.724 0 010-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 01-7.587 3.15z" fill="#010002"/></svg>
      </button>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import projectData from "@/data/projectData";
import { languageHelper, analyticsHelper } from "@/helpers";

export default {
  name: "ProjectCarousel",

  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      indexes: {
        currentPageIndex: 0,
        currentCategoryIndex: 0,
      },
      nextIndexes: {},
      maxItems: 3,
      pageCount: 2,
      sliding: false,
      projects: projectData,
      languageHelper,
      analyticsHelper,
    };
  },
  mounted() {
    this.calcMaxItems();
    this.recalculatePageCount();
    window.addEventListener("resize", () => {
      this.calcMaxItems();
      this.recalculatePageCount();
    });
  },
  methods: {
    categoryIndexSelected(newIndex) {
      if (newIndex === this.indexes.currentCategoryIndex) return;
      this.nextIndexes = {
        currentCategoryIndex: newIndex,
        currentPageIndex: 0,
      };
      this.recalculatePageCount();
      this.slidingFade();
      this.analyticsHelper.projectCategory(
        this.projects[newIndex].categoryName
      );
    },
    pageIndexSelected(newIndex) {
      if (this.sliding) return;

      const indexMax = this.pageCount - 1;
      if (newIndex < 0) {
        newIndex = indexMax;
      } else if (newIndex > indexMax) {
        newIndex = 0;
      }
      if (newIndex === this.indexes.currentPageIndex) return;
      this.nextIndexes = { currentPageIndex: newIndex };
      this.slidingFade();
      this.analyticsHelper.projectCategory(
        `${
          this.projects[this.indexes.currentCategoryIndex].categoryName
        }; page:${newIndex}`
      );
      if (window.innerWidth < 576) {
        const element = document.getElementById("ProjectCarousel");
        element.scrollIntoView(true);
      }
    },
    recalculatePageCount() {
      let next = this.nextIndexes.currentCategoryIndex;
      if (next === null || next === undefined)
        next = this.indexes.currentCategoryIndex;
      const newPageCount = Math.ceil(
        this.projects[next].items.length / this.maxItems
      );
      this.pageCount = newPageCount;
      if (this.indexes.currentPageIndex > newPageCount - 1) {
        this.indexes.currentPageIndex = newPageCount - 1;
      }
    },
    calcMaxItems() {
      const width = window.innerWidth;
      if (width > 1015 || width <= 584) {
        this.maxItems = 3;
      } else {
        this.maxItems = 2;
      }
    },
    slidingFade() {
      this.sliding = true;
      setTimeout(() => {
        this.indexes = { ...this.indexes, ...this.nextIndexes };
        this.nextIndexes = {};
        setTimeout(() => {
          this.sliding = false;
        }, 10);
      }, 400);
    },
    ...mapActions(["setModalData"]),
  },
};
</script>

<style lang="scss" >
$mobile: 584px;
#ProjectCarousel {
  position: relative;
  width: 100%;
  min-height: 80vh;
  z-index: 5;
  background: #fff;
  padding-top: 60px;
  // padding-bottom: 80px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .content-container {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    padding-top: 100px;
    padding-bottom: 100px;
    @media (max-width: $mobile) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      padding-top: 70px;
      padding-bottom: 70px;
    }
  }

  h3 {
    font-size: 52px;
    font-family: $font-header;
    margin-top: 40px;
  }
  span {
    color: $lt-secondary-color;
    font-size: 17px;
    font-family: $font-header;
    margin-top: 4px;
  }
  p {
    font-size: 20px;
    font-family: $font-primary;
    width: 650px;
    margin-top: 20px;
  }
  .slidingfade {
    transition: opacity 0.35s ease-out !important;
    opacity: 0 !important;
  }
  .project-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-right: 22px;
    padding: 0 10px;
    flex: 1;
    max-width: 450px;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      margin-right: 0;
      padding-right: 0;
    }
    img {
      width: 100%;
      height: 210px;
      max-height: 210px;
      object-fit: contain;
      border-radius: 22px;
      cursor: pointer;
    }
    a {
      width: 100%;
    }
    @media (max-width: $mobile) {
      padding: 0;
      margin: 0;
      margin-bottom: 50px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .project-extra {
    color: #000;
    font-family: $font-primary;
    font-size: 16px;
    min-width: 98px;
    padding: 2px 4px;
    background-color: $lt-secondary-color;
    cursor: pointer;
  }
  .project-stack {
    color: $lt-secondary-color;
    font-size: 17px;
    font-family: $font-header;
    margin-top: 4px;
    @media (max-width: $md) {
      // width: 330px;
      max-width: 90%;
    }
  }
  .visit {
    font-family: $font-secondary !important;
    font-size: 14px !important;
    color: $lt-dark-gray;
    margin-left: 15px;
    // line-height: 35px;
    margin-top: 0;
  }
  .project-title {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    margin-top: 42px;

    .title {
      color: #000;
      font-family: $font-primary;
      font-size: 22px;
      padding-right: 12px;
      margin-top: 0;
    }
  }
  a {
    text-decoration: none;
    outline: none;
  }

  .tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    @media (max-width: $md) {
      justify-content: center;
    }

    .tab {
      background-color: transparent;
      border: none;
      font-family: $font-primary;
      font-size: 21px;
      color: #000000;
      letter-spacing: 0;
      line-height: 41.6px;
      margin-right: 22px;
      position: relative;
      outline: none;
      transition: all 0.2s ease-in;
      &:last-child {
        margin-right: 0;
      }
    }
    .tabhighlight {
      color: $lt-secondary-color;
      font-size: 42px;
    }
  }

  svg,
  img {
    height: 24px;
    width: 24px;
  }
  .pagination {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    div {
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background: $lt-dark-gray;
      margin-right: 12px;
      transition: all 0.15s ease-in;
      &:last-child {
        margin-right: 0;
      }
    }
    .activePage {
      background: $lt-secondary-color;
      height: 26px;
      width: 26px;
    }
  }
  .arrow-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0;
  }
  .arrow-extra {
    margin-top: 60px;
  }
  .galArrow {
    transition: all 0.2s ease-in-out;
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      height: 32px;
      width: 32px;
    }
    path {
      fill: #000;
    }
    &:hover {
      path {
        fill: $lt-secondary-color;
      }
    }
  }
  .grayArrow {
    path {
      fill: $lt-gray;
    }
  }

  #prevArrow {
    left: -84px;
    img,
    svg {
      transform: rotate(180deg);
      outline: none;
    }
  }
  #nextArrow {
    right: -84px;
    img,
    svg {
      outline: none;
    }
  }
  .galArrow:focus {
    outline: none;
  }
}
</style>


<style lang="scss" >
$mobile: 584px;
.dark {
  #ProjectCarousel {
    background: $dt-bg-color;

    h3 {
    }
    span {
      color: $dt-secondary-color;
    }

    .project-extra {
      color: #000 !important;
      background-color: $dt-secondary-color;
    }
    .project-stack {
      color: $dt-secondary-color;
    }
    .visit {
      color: $lt-gray;
    }
    .project-title {
      span {
        color: $dt-font-color;
      }
      .title {
        color: $dt-font-color;
      }
    }

    .tab {
      color: $dt-font-color;
    }
    .tabhighlight {
      color: $dt-secondary-color !important;
    }

    .pagination {
      div {
        background: $dt-dark-gray;
      }
      .activePage {
        background: $dt-secondary-color;
      }
    }

    .galArrow {
      path {
        fill: $dt-font-color;
      }
      &:hover {
        path {
          fill: $dt-secondary-color;
        }
      }
    }
    .grayArrow {
      path {
        fill: $lt-gray;
      }
    }
  }
}
</style>
